import React from "react";
import "../Styles/Static.css";
import founderImage from '../../Asserts/Venkadesh_pic.png'; 
import sketchBg from '../../Asserts/back_sketch.png'; 
import { motion } from 'framer-motion';
import { FaSolarPanel, FaCertificate, FaShieldAlt, FaLeaf, FaFileContract, FaAward } from 'react-icons/fa';



const textContainerVariants = {
  hidden: { opacity: 0, x: -50 },
  visible: { 
    opacity: 1, 
    x: 0, 
    transition: { duration: 0.8 }
  },
};

const quoteVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 },
};

  const sustainabilityPoints = [
    { text: 'As a Group we invested in 3.5 MV of Captive Renewable Energy', icon: <FaSolarPanel /> },
    { text: 'Stahlform manufacturing is ISO14001 Certified', icon: <FaCertificate /> },
    { text: 'EHS policy implemented in letter and spirit', icon: <FaShieldAlt /> },
    { text: '50% of Stahlform area has green cover', icon: <FaLeaf /> },
  ];

const Static = () => {
  return (
    <div className="ourstory-container">
      {/* ---------- Top Story Section ---------- */}
      <div
        className="story-top"
       

      >
        {/* Overlay */}
        <div className="overlay"></div>
          
        
        <div className="story-content">
          
          <div className="story-text">
            
            <h2 className="story-title">
              Our Story
            </h2>
            <p>
              With a legacy spanning over five decades, Shanti Electricals has
              forged an unparalleled reputation as a reliable partner in
              designing, supplying, installing, and commissioning electrical
              sub-stations and power distribution systems, from Low Voltage (LV)
              to Extra High Voltage (EHV) across diverse markets.
            </p>
            <p>
              From humble beginnings in 1994, Stahlform emerged to bolster
              Shanti Electricals, growing today into a distinguished brand
              specializing in low voltage and medium voltage panels. With a
              robust footprint in both the private and public sectors, Stahlform
              caters to a wide array of markets and applications, solidifying
              its position as a premier provider of electrical solutions.
            </p>
          </div>
        </div>
      </div>

      {/* Credentials Cards */}
      <div className="credentials-strip">
        <div className="credential-card">
          <div className="credential-icon"><FaFileContract /></div>
          <h4>Licensed Contractor</h4>
          <p>Unlimited voltage licensed contractor across Tamil Nadu, Karnataka, Andhra Pradesh, Telangana & Pondicherry</p>
        </div>
        <div className="credential-card">
          <div className="credential-icon"><FaAward /></div>
          <h4>CPWD Empaneled</h4>
          <p>Empaneled CPWD Contractor in composite class (Civil, Electrical & Mechanical) up to INR 50 cr contract value</p>
        </div>
      </div>

     <div className="founder-message-section">
      
      <h2 className="section-title-drives">
        What <span className="highlight-drives">drives</span> us
      </h2>
      
      <div className="content-wrapper">
        
        {/* Quote box with sketch background */}
        <motion.div
          className="quote-container"
          style={{ backgroundImage: `url(${sketchBg})` }}
          variants={textContainerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {/* Overlay */}
          <div className="sketch-overlay"></div>

          <div className="quote-content">
            <motion.p className="quote-text small-quote" variants={quoteVariants}>
              Curiosity and passion for achieving big made me an entrepreneur.  
              Invincible spirit and relentless working attitude helped me succeed.
            </motion.p>

            <motion.p className="quote-text small-quote" variants={quoteVariants}>
              As electrical engineers, it is our responsibility to employ new 
              technology and systems for energy efficient power generation, 
              distribution and utilization.
            </motion.p>
          </div>
        </motion.div>

        {/* Founder Image */}
        <div className="founder-details">
          <div className="founder-image-wrapper">
            <img 
              src={founderImage} 
              alt="Sri A K Venkatasamy" 
              className="founder-image"
            />
          </div>
          <p className="founder-name">Sri A K Venkatasamy</p>
        </div>
      </div>
    </div>
     <div className="sustainability-container">
      
      <h2 className="sustainability-title">
        Delivering on <span className="highlight">Sustainability</span>
      </h2>

      {/* Points */}
      <div className="points-grid">
        {sustainabilityPoints.map((point, index) => (
          <div key={index} className="point-item">
            <span className="bullet-icon">{point.icon}</span>
            <p className="point-text">{point.text}</p>
          </div>
        ))}
      </div>

      {/* License Info */}
     
    </div>

    
    </div>
  );
};

export default Static;
